import { IState } from '../../store';

export const selectIsChatsEnabled = (state: IState): boolean => {
  return state.offerChat.isChatsEnabled;
};
